import React, {useContext, useEffect} from "react";
import {useTranslation} from "react-i18next";
import DataList from "common/src/components/widget/DataList";
import {dateToString} from "common/src/utils/DateUtils";
import {fetchAccessLogPage} from "../../../state/api/accessLogAPI";
import {UserContext} from "../../../context/UserContext";
import {hasRole} from "../../../utils/userUtils";
import {Role} from "../../../auth/roles";
import Unauthorized from "../Unauthorized";

const AccessLog = () => {
    const {t} = useTranslation();
    const {user} = useContext(UserContext);

    if (!hasRole(user, Role.AUDIT_READ)) {
        return <Unauthorized/>
    }

    return <DataList
        selector={(state) => state.accessLogAPI.list}
        fetchAction={fetchAccessLogPage}
        columns={[
            {name: t('audit.user'), id: "userId", disableSort: true},
            {name: t('audit.dataset_name'), id: "datasetName", disableSort: false},
            {name: t('audit.is_public_dataset'), id: "datasetIsPublic", disableSort: true},
            {name: t('audit.ip_address'), id: "ipAddress", disableSort: false},
            {
                name: t('audit.accessed_at'),
                id: "accessedAt",
                disableSort: false,
                cellComponent: (row) => <div>{dateToString(row.accessedAt, false, true)}</div>
            },
        ]}
        defaultSort={"accessedAt,desc"}
        showCreateButton={false}
        disableOnClick={true}
    />
}

export default AccessLog;
